var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 0.267334V12.2673L3.51562 20.7526C5.6872 22.9242 8.6872 24.2673 12.0009 24.2673C18.6283 24.2673 24.0009 18.8947 24.0009 12.2673C24.0009 5.63996 12.0009 0.267334 12.0009 0.267334Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 0.267334C8.6872 0.267334 5.6872 1.61049 3.51562 3.78202C6.45984 6.72624 7.50501 7.77146 12.0009 12.2673H24.0009C24.0009 5.63996 18.6283 0.267334 12.0009 0.267334Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2182 12.2691L6.7527 11.5797L7.53312 10.1604L5.94172 10.4649L5.74006 8.85718L4.63156 10.0396L3.52311 8.85718L3.32141 10.4649L1.73005 10.1604L2.51047 11.5797L1.04492 12.2691L2.51047 12.9584L1.73005 14.3777L3.32155 14.0733L3.52306 15.681L4.63156 14.4986L5.74006 15.681L5.94172 14.0733L7.53303 14.3778L6.75266 12.9585L8.2182 12.2691Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2018 4.96265L3.68948 5.64435L4.48847 5.39127L3.99075 6.06571L4.47844 6.74741L3.68316 6.48252L3.18548 7.15691L3.19172 6.31879L2.39648 6.05385L3.19561 5.80077L3.2018 4.96265Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2018 17.3769L3.68948 18.0586L4.48847 17.8055L3.99075 18.48L4.47844 19.1617L3.68316 18.8968L3.18548 19.5712L3.19172 18.7331L2.39648 18.4681L3.19561 18.2151L3.2018 17.3769Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1578 11.1697L9.67013 11.8514L8.87109 11.5982L9.36881 12.2727L8.88113 12.9544L9.67641 12.6895L10.1741 13.3639L10.1678 12.5258L10.9631 12.2609L10.164 12.0078L10.1578 11.1697Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PHP.0a52038ddf1c1b9fd0a72d28f6d4b318.svg";